import {Component, Input, OnInit} from "@angular/core";
import {CmPartnerBaseComponent} from "../cm-partner-base.component";
import {NavigationItem} from "../../../../../../../core/shared/dto/navigation/navigation-item";
import {PartnerDto} from "../../../../../model/dto/entity/partner.dto";

@Component({
    selector: 'cm-partner-side',
    templateUrl: 'cm-partner-side.component.html',
    standalone: false
})

export class CmPartnerSideComponent extends CmPartnerBaseComponent implements OnInit {
    @Input() dto: PartnerDto;

    navigationItems: NavigationItem[] = [
        {
            label: 'cm.Partner',
            action: 'cm.Partner',
            tooltip: 'Partner Basic Info',
            icon: 'fa-solid fa-id-card',
            toggleable: false,
            default: true
        },
        {
            label: 'cm.PartnerGroup',
            action: 'cm.PartnerGroup',
            tooltip: 'Partner Group',
            icon: 'fa-solid fa-users',
            toggleable: false,
            default: false
        },
        {
            label: 'cm.PartnerLink',
            action: 'cm.PartnerLink',
            tooltip: 'Partner Link',
            icon: 'fa-solid fa-link',
            toggleable: false,
            default: false
        },
    ];

    ngOnInit() {
        super.ngOnInit();

    }
}